import React, { useEffect, useState } from "react";
import { FaChevronRight, FaSearch } from "react-icons/fa";
import Logo from "../../assets/img/logo.png";
import LogoDark from "../../assets/img/logo-dark.png";
import { FiPhone } from "react-icons/fi";
import { IoClose, IoMenu } from "react-icons/io5";
import { FaChevronDown } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../api";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const Header = ({ setResetCat }) => {
  const [open, setOpen] = useState(false);
  const [openChildIndex, setOpenChildIndex] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobilMenu, setMobilMenu] = useState(false);
  const [active, setActive] = useState(false);
  const [mobileMenuData, setMobileMenuData] = useState([]);
  const [data, setData] = useState([]);
  const [images, setImages] = useState([]);
  const [showChildren, setShowChildren] = useState(false);
  const [category, setCategory] = useState("");
  const [mainCatData, setMainCatData] = useState([]);
  const [products, setProducts] = useState([]);
  const [value, setValue] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openSolutions, setOpenSolutions] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const width = window.innerWidth;

  useEffect(() => {
    if (mobileMenuData.length > 0) {
      const firstCategory = mobileMenuData[0];
      handleOpenChildren(
        firstCategory.id,
        firstCategory.products || [],
        firstCategory.images || []
      );
    }
  }, [mobileMenuData]);

  useEffect(() => {
    axiosClient.get("/Category/GetAllCategoryHierarchy").then((res) => {
      setMobileMenuData(res.data.categories);
    });
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [location.pathname]);
  
  const handleLeave = () => {
    setOpen(false);
    setOpenChildIndex(null);
    setShowChildren(false); // opsiyonel: alt kategori görünmesini istemiyorsan
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpenChildren = (id, item = [], images = []) => {
    const mainCat = mobileMenuData.find((cat) => cat.id === id);
    setMainCatData(mainCat);
    setOpenChildIndex(id);
    setData(item);
    setImages(images);
  };

  const toggleMobileMenu = () => {
    setMobilMenu(!mobilMenu);
  };
  console.log(data);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const threshold = 200;
      if (scrollPosition > threshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");
    if (categoryParam) {
      setCategory(categoryParam);
    }
  }, [location.search]);

  const handleCategoryClick = (item) => {
    setOpen(false);
    const query = new URLSearchParams({
      category: item.name,
    }).toString();
    navigate(`/urunler?${query}`);
  };

  useEffect(() => {
    axiosClient
      .post(`/Filter/FilterProduct`)
      .then((res) => {
        setAllProducts(res?.data?.products);
        setProducts(res?.data?.products);
      })
      .catch((error) => {
        console.error("Error while fetching filtered data:", error);
      });
  }, []);

  useEffect(() => {
    if (value === "") {
      setProducts(allProducts);
      setLoading(false); // Stop loading when the input is cleared
    } else {
      setLoading(true);
      const filteredProducts = allProducts.filter((product) =>
        product?.product?.name.toLowerCase().includes(value.toLowerCase())
      );
      setProducts(filteredProducts);
      setLoading(false); // Stop loading once filtering is complete
    }
  }, [value, allProducts]);
  return (
    <div>
      {active ? (
        <header
          className={`${
            width < 768 ? `fixed ${isScrolled ? "bg-main" : ""}` : "absolute"
          } top-0 w-full z-[99999]`}
        >
          <div className="h-12 container mx-auto hidden md:flex items-center justify-between border-b relative">
            <div className="flex-1 flex flex-row items-center justify-between gap-20 text-white">
              <div className="flex items-center gap-10">
                <div className="flex items-center gap-2">
                  <FiPhone size={26} />
                  <p>Destek Hattı:</p>
                  <a href="tel:+908507377564" className="font-semibold">
                    +90 850 737 7564
                  </a>
                </div>
                <div>
                  <a href="mailto:info@lensa.com.tr" className="font-semibold">
                    info@lensa.com.tr
                  </a>
                </div>
              </div>
              <div className="gap-5 md:flex hidden items-center">
                <div className="flex items-center relative">
                  <input
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="py-1 outline-none border bg-transparent placeholder:text-white placeholder:font-normal px-2 border-white rounded-md"
                    type="text"
                    placeholder="Ürün Ara..."
                  />
                  <FaSearch className="text-white absolute right-3 cursor-pointer" />
                  {value && loading && (
                    <div className="absolute top-10 left-0 flex items-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-white"></div>
                    </div>
                  )}
                  {value && !loading && (
                    <div
                      className={`absolute top-full left-0 w-full bg-white z-50 overflow-y-scroll custom-scrollbar-header ${
                        products.length > 5 ? "h-96" : ""
                      }`}
                    >
                      {products.map((product) => (
                        <Link
                          onClick={() => setValue("")}
                          key={product?.product?.permalink}
                          to={`/urunler/urun-detay/${product?.product?.permalink}`}
                          className="block py-2 px-3 border-b border-gray-200 text-black"
                        >
                          {product?.product?.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="md:hidden">
              <div className="container mx-auto default">
                <div className="flex items-center justify-between">
                  <div className="">
                    <Link to="/">
                      <img src={Logo} alt="lensa Logo" />
                    </Link>
                  </div>

                  <div className=" flex justify-end items-center space-x-4">
                    <button className="text-2xl">
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden max-md:block">
            {/* Mobile menu content */}
            <div
              className={
                mobilMenu
                  ? "bg-white px-5 h-20 flex items-center justify-between w-full border-b border-main"
                  : "px-5 h-20 flex items-center justify-between w-full border-b border-white"
              }
            >
              <div className="w-full">
                {mobilMenu ? (
                  <Link to="/">
                    <img src={LogoDark} alt="lensa Logo" className="w-36" />
                  </Link>
                ) : (
                  <Link to="/">
                    <img src={Logo} alt="lensa Logo" className="w-36" />
                  </Link>
                )}
              </div>

              <div className="flex justify-end items-center space-x-4">
                <button className="text-2xl" onClick={toggleMobileMenu}>
                  {mobilMenu ? (
                    <IoClose className="text-main" size={40} />
                  ) : (
                    <IoMenu className="text-white" size={40} />
                  )}
                </button>
              </div>
            </div>

            {/* Display mobile menu items */}
            {mobilMenu && (
              <ul className="z-50 text-white absolute top-20 left-0 w-full h-[calc(100vh-4rem)] bg-white flex flex-col py-5">
                <Link to="/">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    Anasayfa
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <li
                  className={`flex items-start flex-col justify-between text-xl font-medium text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4 ${
                    showChildren
                      ? "h-[400px] overflow-y-scroll custom-scrollbar"
                      : ""
                  }`}
                  onClick={() => setShowChildren(!showChildren)}
                >
                  <span className="flex justify-between items-center w-full font-semibold">
                    Ürünler
                    {showChildren ? (
                      <MdOutlineKeyboardArrowDown size={20} />
                    ) : (
                      <MdOutlineKeyboardArrowRight size={20} />
                    )}
                  </span>
                  {showChildren &&
                    mobileMenuData.map((item) => (
                      <ul className="flex flex-col">
                        <li className="text-base">
                          <span
                            onClick={() => {
                              handleCategoryClick(item);
                              setMobilMenu(false);
                            }}
                          >
                            {item.name}
                          </span>
                          {item.subCategories.length > 0 &&
                            item.subCategories.map((sub) => (
                              <ul className="flex flex-col">
                                <li className="text-base">
                                  <span
                                    onClick={() => {
                                      handleCategoryClick(sub);
                                      setMobilMenu(false);
                                    }}
                                  >
                                    {sub.name}
                                  </span>
                                </li>
                              </ul>
                            ))}
                        </li>
                      </ul>
                    ))}
                </li>
                <Link to="/hakkimizda">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    Hakkımızda
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <Link to="/referanslar">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    Referanslarımız
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <Link to="/iletisim">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    İletişim
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <li className="flex flex-col font-medium text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4">
                  <span className="text-xl font-semibold">İstanbul Ofis:</span>
                  <span className="text-md mb-3">
                    Kaptanpaşa Mah. Halit Ziya Türkkan Sok. Famas Plaza C Blok
                    No: 19 Şişli / İstanbul
                  </span>
                  <a href="tel:+908507377564" className="mb-3 underline">
                    +90 850 737 7564
                  </a>
                  <a href="mailto:info@lensa.com.tr" className="underline">
                    info@lensa.com.tr
                  </a>
                </li>
              </ul>
            )}
          </div>

          <div
            className={`text-white max-md:mt-0 mt-3 ${
              isScrolled
                ? `fixed top-0 w-full z-[99999] !mt-0 bg-white !text-black py-2 ${
                    width < 768 ? "hidden" : ""
                  }`
                : ""
            }`}
          >
            <div className="container relative max-md:hidden">
              <div className="flex items-center">
                <div className="flex-1 text-left">
                  {isScrolled ? (
                    <Link to="/">
                      <img
                        src={LogoDark}
                        className="w-44"
                        alt="lensa Bilişim Sistemleri Logo"
                      />
                    </Link>
                  ) : (
                    <Link to="/">
                      <img
                        src={Logo}
                        className="w-44"
                        alt="lensa Bilişim Sistemleri Logo"
                      />
                    </Link>
                  )}
                </div>
                <ul
                  className={`flex relative mt-5 max-lg:mt-0 ${
                    isScrolled ? "!mt-0" : ""
                  }`}
                >
                  <li className="flex items-center text-lg font-semibold px-5 border-b border-transparent hover:border-b hover:border-white cursor-pointer transition-all duration-300 max-lg:px-1">
                    <Link to="/">Anasayfa</Link>
                  </li>
                  <li
                    onMouseEnter={handleOpen}
                    onMouseLeave={handleLeave}
                    onClick={() => {
                      navigate("/urunler", {
                        state: { name: "" },
                      });
                      setOpen(false);
                    }}
                    className="flex items-center gap-2 text-lg font-semibold rounded-sm duration-300  cursor-pointer"
                  >
                    <Link>Ürünler</Link>
                    <FaChevronDown size={12} />
                  </li>
                  <li className="flex items-center text-lg font-semibold px-5 border-b border-transparent hover:border-b hover:border-white cursor-pointer transition-all duration-300 max-lg:px-1">
                    <Link to="/hakkimizda">Hakkımızda</Link>
                  </li>
                  <li className="flex items-center text-lg font-semibold pr-5 border-b border-transparent hover:border-b hover:border-white cursor-pointer transition-all duration-300 max-lg:px-1">
                    <Link to="/referanslar">Referanslarımız</Link>
                  </li>
                  <li className="flex items-center text-lg font-semibold py-3 hover:border-b cursor-pointer transition-all duration-300">
                    <Link to="/iletisim">İletişim</Link>
                  </li>
                </ul>
                {open && (
                  <div
                    onMouseEnter={handleOpen}
                    onMouseLeave={handleLeave}
                    className="absolute z-50 top-full left-0 container h-[400px] overflow-hidden w-full bg-white border border-gray-200"
                  >
                    <div className="flex text-main font-normal h-full">
                      <ul className="w-full z-50 flex-[2_2_0] overflow-y-scroll mobile-list">
                        {mobileMenuData
                          .sort((a, b) => a.priority - b.priority)
                          .map((item) => (
                            <li
                              key={item.id}
                              className="border-b px-5 py-2 flex flex-col justify-between bg-white font-medium cursor-pointer"
                            >
                              <span className="flex items-center justify-between">
                                <span
                                  className="font-bold"
                                  onClick={() => {
                                    setOpen(false);
                                    const query = new URLSearchParams({
                                      category: item.name,
                                    }).toString();

                                    navigate(`/urunler?${query}`);
                                  }}
                                  onMouseEnter={() =>
                                    handleOpenChildren(
                                      item.id,
                                      item?.product,
                                      item?.images
                                    )
                                  }
                                  onMouseLeave={() => setOpenChildIndex(null)}
                                >
                                  {item.name}
                                </span>
                                {item.subCategories.length > 0 ? (
                                  <FaChevronDown size={12} />
                                ) : (
                                  <FaChevronRight size={12} />
                                )}
                              </span>
                              <ul>
                                {item.subCategories.map((sub) => {
                                  return (
                                    <li
                                      key={sub.id}
                                      onClick={() => {
                                        setOpen(false);
                                        const query = new URLSearchParams({
                                          category: sub.name,
                                        }).toString();

                                        navigate(`/urunler?${query}`);
                                      }}
                                      onMouseEnter={() =>
                                        handleOpenChildren(
                                          sub.id,
                                          sub.product,
                                          item?.images
                                        )
                                      }
                                      onMouseLeave={() =>
                                        setOpenChildIndex(null)
                                      }
                                    >
                                      {sub.name.includes("-1")
                                        ? sub.name.slice(0, -2)
                                        : sub.name}
                                    </li>
                                  );
                                })}
                              </ul>
                            </li>
                          ))}
                      </ul>
                      <div className="flex-[8_8_0] relative p-5">
                        <div className="mb-2 flex items-center justify-between">
                          <h1 className="text-2xl font-semibold text-main">
                            Popüler Ürünler
                          </h1>
                          <span
                            onClick={() => {
                              setOpen(false);
                              const query = new URLSearchParams({
                                category: data[0]?.categoryName,
                              }).toString();

                              navigate(`/urunler?${query}`);
                            }}
                            className="text-main text-lg font-semibold underline cursor-pointer"
                          >
                            Tümünü Gör
                          </span>
                        </div>
                        <div className="flex items-center flex-wrap overflow-hidden gap-10">
                          {data?.slice(0, 5).length > 0
                            ? data
                                .filter((item) => item.isTopSeller)
                                .slice(0, 5)
                                .map((item) => (
                                  <Link
                                    onClick={() => setOpen(false)}
                                    to={`/urunler/urun-detay/${item.permalink}`}
                                    key={item.id}
                                    className="w-[15%]"
                                  >
                                    <div className="flex flex-col items-center gap-7">
                                      <div className="flex items-center justify-center">
                                        <img
                                          src={`https://cdn.lensa.com.tr/${item?.images?.[0]?.photoUrl}`}
                                          alt={item.name}
                                          className="w-[250px] h-[250px] object-contain"
                                        />
                                      </div>
                                      <p className="text-lg font-medium hover:underline flex-[2_2_0] max-2xl:text-[1.1rem] leading-tight line-clamp-1">
                                        {item.name}
                                      </p>
                                    </div>
                                  </Link>
                                ))
                            : mainCatData?.subCategories?.map((item) =>
                                item?.product?.slice(0, 5).map((product) => (
                                  <Link
                                    onClick={() => setOpen(false)}
                                    to={`/urunler/urun-detay/${product.permalink}`}
                                    key={product.id}
                                    className="w-[15%]"
                                  >
                                    <div className="flex flex-col items-center gap-7">
                                      <div className="flex items-center justify-center">
                                        <img
                                          src={`https://cdn.lensa.com.tr/${product?.images?.[0]?.photoUrl}`}
                                          alt={product.name}
                                          className="w-[250px] h-[250px] object-contain"
                                        />
                                      </div>
                                      <p className="text-lg font-medium hover:underline flex-[2_2_0] max-2xl:text-[1.1rem] leading-tight line-clamp-1">
                                        {product.name}
                                      </p>
                                    </div>
                                  </Link>
                                ))
                              )}
                        </div>
                      </div>
                      {/** <div className="flex-[2_2_0] border-l-2">
                        <img
                          src={
                            images?.length > 0
                              ? `https://cdn.lensa.com.tr/${images[0]?.photoUrl}`
                              : Man
                          }
                          alt="Telefon Tutan Adam"
                          className="w-full h-auto"
                        />
                      </div> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>
      ) : (
        <header
          className={`${
            isScrolled ? "fixed top-0 bg-main" : "relative bg-main"
          } w-full z-[99998] bg-main`}
        >
          <div className="h-12 container mx-auto hidden md:flex items-center justify-between border-b relative">
            <div className="flex-1 flex flex-row items-center justify-between gap-20 text-white">
              <div className="flex items-center gap-10">
                <div className="flex items-center gap-2">
                  <FiPhone size={26} />
                  <p>Destek Hattı:</p>
                  <a href="tel:+908507377564" className="font-semibold">
                    +90 850 737 7564
                  </a>
                </div>
                <div>
                  <a href="mailto:info@lensa.com.tr" className="font-semibold">
                    info@lensa.com.tr
                  </a>
                </div>
              </div>

              <div className="gap-5 md:flex hidden items-center">
                <div className="flex items-center relative">
                  <input
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="py-1 outline-none border bg-transparent placeholder:text-white placeholder:font-normal px-2 border-white rounded-md"
                    type="text"
                    placeholder="Ürün Ara..."
                  />
                  <FaSearch className="text-white absolute right-3 cursor-pointer" />
                  {value && loading && (
                    <div className="absolute top-10 left-0 flex items-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-white"></div>
                    </div>
                  )}
                  {value && !loading && (
                    <div
                      className={`absolute top-full left-0 w-full bg-white z-50 overflow-y-scroll custom-scrollbar-header ${
                        products.length > 5 ? "h-96" : ""
                      }`}
                    >
                      {products.map((product) => (
                        <Link
                          onClick={() => setValue("")}
                          key={product?.product?.permalink}
                          to={`/urunler/urun-detay/${product?.product?.permalink}`}
                          className="block py-2 px-3 border-b border-gray-200 text-black"
                        >
                          {product?.product?.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="md:hidden">
              <div className="container mx-auto default">
                <div className="flex items-center justify-between">
                  <div className="">
                    <Link to="/">
                      <img src={Logo} alt="lensa Logo" />
                    </Link>
                  </div>

                  <div className=" flex justify-end items-center space-x-4">
                    <button className="text-2xl">
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden max-md:block">
            {/* Mobile menu content */}
            <div
              className={
                mobilMenu
                  ? "bg-white px-5 h-20 flex items-center justify-between w-full border-b border-main"
                  : "px-5 h-20 flex items-center justify-between w-full border-b border-white"
              }
            >
              <div className="w-full">
                {mobilMenu ? (
                  <Link to="/">
                    <img src={LogoDark} alt="lensa Logo" className="w-36" />
                  </Link>
                ) : (
                  <Link to="/">
                    <img src={Logo} alt="lensa Logo" className="w-36" />
                  </Link>
                )}
              </div>

              <div className="flex justify-end items-center space-x-4">
                <button className="text-2xl" onClick={toggleMobileMenu}>
                  {mobilMenu ? (
                    <IoClose className="text-main" size={40} />
                  ) : (
                    <IoMenu className="text-white" size={40} />
                  )}
                </button>
              </div>
            </div>

            {/* Display mobile menu items */}
            {mobilMenu && (
              <ul className="z-50 text-white absolute top-20 left-0 w-full h-[calc(100vh-4rem)] bg-white flex flex-col py-5">
                <Link to="/">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    Anasayfa
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <li
                  className={`flex items-start flex-col justify-between text-xl font-medium text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4 ${
                    showChildren
                      ? "h-[400px] overflow-y-scroll custom-scrollbar"
                      : ""
                  }`}
                  onClick={() => setShowChildren(!showChildren)}
                >
                  <span className="flex justify-between items-center w-full font-semibold">
                    Ürünler
                    {showChildren ? (
                      <MdOutlineKeyboardArrowDown size={20} />
                    ) : (
                      <MdOutlineKeyboardArrowRight size={20} />
                    )}
                  </span>
                  {showChildren &&
                    mobileMenuData.map((item) => (
                      <ul className="flex flex-col">
                        <li className="text-base">
                          <span
                            onClick={() => {
                              const query = new URLSearchParams({
                                category: item.name,
                              }).toString();

                              navigate(`/urunler?${query}`);
                              setMobilMenu(false);
                            }}
                          >
                            {item.name}
                          </span>
                          {item.subCategories.length > 0 &&
                            item.subCategories.map((sub) => (
                              <ul className="flex flex-col">
                                <li className="text-base">
                                  <span
                                    onClick={() => {
                                      handleCategoryClick(sub);
                                      setMobilMenu(false);
                                    }}
                                  >
                                    {sub.name}
                                  </span>
                                </li>
                              </ul>
                            ))}
                        </li>
                      </ul>
                    ))}
                </li>
                <Link to="/hakkimizda">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    Hakkımızda
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <Link to="/referanslar">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    Referanslarımız
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <Link to="/iletisim">
                  <li
                    className="flex items-center justify-between text-xl font-semibold text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4"
                    onClick={() => setMobilMenu(false)}
                  >
                    İletişim
                    <MdOutlineKeyboardArrowRight size={20} />
                  </li>
                </Link>
                <li className="flex flex-col font-medium text-main border-b-[0.1rem] border-b-[#eaeaea] py-3 px-4">
                  <span className="text-xl font-semibold">İstanbul Ofis:</span>
                  <span className="text-md mb-3">
                    Kaptanpaşa Mah. Halit Ziya Türkkan Sok. Famas Plaza C Blok
                    No: 19 Şişli / İstanbul
                  </span>
                  <a href="tel:+908507377564" className="mb-3 underline">
                    +90 850 737 7564
                  </a>
                  <a href="mailto:info@lensa.com.tr" className="underline">
                    info@lensa.com.tr
                  </a>
                </li>
              </ul>
            )}
          </div>
          <div className="container relative max-md:hidden mt-3">
            <div className="flex items-center">
              <div className="flex-1 text-left">
                <Link to="/">
                  <img
                    src={Logo}
                    className="w-44"
                    alt="lensa Bilişim Sistemleri Logo"
                  />
                </Link>
              </div>
              <ul
                className={`flex relative mt-5 max-lg:mt-0 ${
                  isScrolled ? "!mt-0" : ""
                }`}
              >
                <li className="flex items-center text-lg font-semibold px-5 border-b border-transparent text-white  cursor-pointer transition-all duration-300">
                  <Link to="/">Anasayfa</Link>
                </li>
                <li
                  onMouseEnter={handleOpen}
                  onMouseLeave={handleLeave}
                  onClick={() => {
                    setOpen(false);
                    setResetCat(true);
                  }}
                  className="flex items-center gap-2 text-lg font-semibold rounded-sm duration-300 text-white cursor-pointer"
                >
                  <Link to="/urunler">Ürünler</Link>
                  <FaChevronDown size={12} />
                </li>

                <li className="flex items-center text-lg font-semibold px-5 border-b border-transparent text-white  cursor-pointer transition-all duration-300">
                  <Link to="/hakkimizda">Hakkımızda</Link>
                </li>
                <li className="flex items-center text-lg font-semibold pr-5 border-b border-transparent text-white  cursor-pointer transition-all duration-300">
                  <Link to="/referanslar">Referanslarımız</Link>
                </li>
                <li className="flex items-center text-lg font-semibold py-3 cursor-pointer text-white transition-all duration-300">
                  <Link to="/iletisim">İletişim</Link>
                </li>
              </ul>
              {open && (
                <div
                  onMouseEnter={handleOpen}
                  onMouseLeave={handleLeave}
                  className="absolute z-50 top-full left-0 container h-[400px] overflow-hidden w-full bg-white border border-gray-200"
                >
                  <div className="flex text-main font-normal h-full">
                    <ul className="w-full z-50 flex-[2_2_0] overflow-y-scroll mobile-list">
                      {mobileMenuData
                        .sort((a, b) => a.priority - b.priority)
                        .map((item) => (
                          <li
                            key={item.id}
                            className="border-b px-5 py-2 flex flex-col justify-between bg-white font-medium cursor-pointer"
                          >
                            <span className="flex items-center justify-between">
                              <span
                                className="font-bold"
                                onClick={() => {
                                  const query = new URLSearchParams({
                                    category: item.name,
                                  }).toString();

                                  setOpen(false);
                                  navigate(`/urunler?${query}`);
                                }}
                                onMouseEnter={() =>
                                  handleOpenChildren(
                                    item.id,
                                    item?.product,
                                    item?.images
                                  )
                                }
                                onMouseLeave={() => setOpenChildIndex(null)}
                              >
                                {item.name}
                              </span>
                              {item.subCategories.length > 0 ? (
                                <FaChevronDown size={12} />
                              ) : (
                                <FaChevronRight size={12} />
                              )}
                            </span>
                            <ul>
                              {item.subCategories.map((sub) => {
                                return (
                                  <li
                                    key={sub.id}
                                    onClick={() => {
                                      setOpen(false);
                                      const query = new URLSearchParams({
                                        category: sub.name,
                                      }).toString();

                                      navigate(`/urunler?${query}`);
                                    }}
                                    onMouseEnter={() =>
                                      handleOpenChildren(
                                        sub.id,
                                        sub.product,
                                        item?.images
                                      )
                                    }
                                    onMouseLeave={() => setOpenChildIndex(null)}
                                  >
                                    {sub.name.includes("-1")
                                      ? sub.name.slice(0, -2)
                                      : sub.name}
                                  </li>
                                );
                              })}
                            </ul>
                          </li>
                        ))}
                    </ul>
                    <div className="flex-[8_8_0] relative p-5">
                      <div className="mb-2 flex items-center justify-between">
                        <h1 className="text-2xl font-semibold text-main">
                          Popüler Ürünler
                        </h1>
                        <span
                          onClick={() => {
                            setOpen(false);
                            const query = new URLSearchParams({
                              category: data[0]?.categoryName,
                            }).toString();

                            navigate(`/urunler?${query}`);
                          }}
                          className="text-main text-lg font-semibold underline cursor-pointer"
                        >
                          Tümünü Gör
                        </span>
                      </div>
                      <div className="flex items-center flex-wrap overflow-hidden gap-10">
                        {data?.slice(0, 5).length > 0
                          ? data
                              .filter((item) => item.isTopSeller)
                              .slice(0, 5)
                              .map((item) => (
                                <Link
                                  onClick={() => setOpen(false)}
                                  to={`/urunler/urun-detay/${item.permalink}`}
                                  key={item.id}
                                  className="w-[15%]"
                                >
                                  <div className="flex flex-col items-center gap-7">
                                    <div className="flex items-center justify-center">
                                      <img
                                        src={`https://cdn.lensa.com.tr/${item?.images?.[0]?.photoUrl}`}
                                        alt={item.name}
                                        className="w-[250px] h-[250px] object-contain"
                                      />
                                    </div>
                                    <p className="text-lg font-medium hover:underline flex-[2_2_0] max-2xl:text-[1.1rem] leading-tight line-clamp-1">
                                      {item.name}
                                    </p>
                                  </div>
                                </Link>
                              ))
                          : mainCatData?.subCategories?.map((item) =>
                              item?.product?.slice(0, 5).map((product) => (
                                <Link
                                  onClick={() => setOpen(false)}
                                  to={`/urunler/urun-detay/${product.permalink}`}
                                  key={product.id}
                                  className="w-[15%]"
                                >
                                  <div className="flex flex-col items-center gap-7">
                                    <div className="flex items-center justify-center">
                                      <img
                                        src={`https://cdn.lensa.com.tr/${product?.images?.[0]?.photoUrl}`}
                                        alt={product.name}
                                        className="w-[250px] h-[250px] object-contain"
                                      />
                                    </div>
                                    <p className="text-lg font-medium hover:underline flex-[2_2_0] max-2xl:text-[1.1rem] leading-tight line-clamp-1">
                                      {product.name}
                                    </p>
                                  </div>
                                </Link>
                              ))
                            )}
                      </div>
                    </div>
                    {/** <div className="flex-[2_2_0] border-l-2">
                        <img
                          src={
                            images?.length > 0
                              ? `https://cdn.lensa.com.tr/${images[0]?.photoUrl}`
                              : Man
                          }
                          alt="Telefon Tutan Adam"
                          className="w-full h-auto"
                        />
                      </div> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>
      )}
    </div>
  );
};

export default Header;
